export const PACKAGE_RATE_ACTION = "PACKAGE_RATE_ACTION";
export const PACKAGE_RATE_SUCCESS = "PACKAGE_RATE_SUCCESS";
export const PACKAGE_RATE_FAIL = "PACKAGE_RATE_FAIL";
export const PACKAGE_RATE_UPDATE_ACTIVE_ACTION = "PACKAGE_RATE_UPDATE_ACTIVE_ACTION";
export const PACKAGE_RATE_DELETE_ACTION = "PACKAGE_RATE_DELETE_ACTION";
export const PACKAGE_RATE_CLONE_ACTION = "PACKAGE_RATE_CLONE_ACTION";
export const PACKAGE_RATE_DETAIL_ACTION = "PACKAGE_RATE_DETAIL_ACTION";
export const PACKAGE_RATE_DETAIL_SUCCESS = "PACKAGE_RATE_DETAIL_SUCCESS";
export const PACKAGE_RATE_UPDATE_ACTION = "PACKAGE_RATE_UPDATE_ACTION";
export const PACKAGE_RATE_CREATE_ACTION = "PACKAGE_RATE_CREATE_ACTION";
export const PACKAGE_RATE_CREATE_SUCCESS = "PACKAGE_RATE_CREATE_SUCCESS";
export const PACKAGE_RATE_UPDATE_TRANSLATE_ACTION = "PACKAGE_RATE_UPDATE_TRANSLATE_ACTION";
export const PACKAGE_RATE_CREATE_TRANSLATE_ACTION = "PACKAGE_RATE_CREATE_TRANSLATE_ACTION";
export const PACKAGE_RATE_GET_TRANSLATE_ACTION = "PACKAGE_RATE_GET_TRANSLATE_ACTION";
export const PACKAGE_RATE_GET_TRANSLATE_SUCCESS = "PACKAGE_RATE_GET_TRANSLATE_SUCCESS";
export const PACKAGE_RATE_CREATE_PRODUCT_ACTION = "PACKAGE_RATE_CREATE_PRODUCT_ACTION";
export const PACKAGE_RATE_UPDATE_PRODUCT_ACTION = "PACKAGE_RATE_UPDATE_PRODUCT_ACTION";
export const PACKAGE_RATE_GET_PRODUCT_ACTION = "PACKAGE_RATE_GET_PRODUCT_ACTION";
export const PACKAGE_RATE_GET_PRODUCT_SUCCESS = "PACKAGE_RATE_GET_PRODUCT_SUCCESS";
export const PACKAGE_RATE_TAB_ACTION = "PACKAGE_RATE_TAB_ACTION";
export const PACKAGE_RATE_RESET_DETAIL = "PACKAGE_RATE_RESET_DETAIL";